import AOS from 'aos';

const aosJs = function () {

  setTimeout(function () {
    AOS.init();
  }, 1000);

    // AOS.init({
    //   duration: 1000,
    //   once: true,
    //   offset: 0
    // });
}

export default aosJs;